module.exports = __webpack_public_path__ + "static/media/bscChain.088ea506.png";